import { Icon } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

import { DiamondIcon } from 'src/components/icons';
import { SidebarThemeContext } from 'src/context';
import { SettingsPlanTag } from 'src/features/settings/SettingsPlanTag';

import {
  SettingsSidebarPlanBadge,
  SettingsSidebarRow as SettingsSidebarRowData,
} from './settingsSidebarSections';

const PlanBadge = ({ badge }: { badge: SettingsSidebarPlanBadge }) => {
  const { sidebarTextColor } = React.useContext(SidebarThemeContext);
  return badge.kind === 'planTag' ? (
    <SettingsPlanTag label={badge.label} />
  ) : (
    <DiamondIcon
      data-testid="upgrade-icon"
      style={{ fontSize: 16, color: sidebarTextColor }}
    />
  );
};

export const SettingsSidebarRow = ({
  row,
  onSelect,
}: {
  row: SettingsSidebarRowData;
  onSelect: (path: string) => void;
}) => {
  // Label and icon share the sidebar theme's text colour, like the main sidebar's rows.
  const { sidebarTextColor } = React.useContext(SidebarThemeContext);

  return (
    <button
      type="button"
      data-testid={`settings-page-${row.id}`}
      aria-current={row.selected ? 'page' : undefined}
      onClick={() => onSelect(row.path)}
      style={{ color: sidebarTextColor }}
      className={clsx(
        'flex w-full cursor-pointer items-center gap-[9px] rounded border-0 px-2 py-1.5 text-left text-[13.5px] leading-5.5',
        'focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[#003DA5] focus-visible:outline-solid',
        row.selected ? 'bg-[#E9EBEE]' : 'bg-transparent hover:bg-gray-150',
      )}
    >
      <Icon icon={row.iconName} className="h-[15px] w-[15px] shrink-0" />
      <span className="min-w-0 flex-1 truncate">{row.label}</span>
      {row.planBadge && <PlanBadge badge={row.planBadge} />}
    </button>
  );
};
